<template>
  <div v-if="shouldDisplayAddedDays()" class="added-date__wrapper">
    <div class="added-date__value">
      <span>{{ getAddedInDaysText() }}</span>
    </div>
  </div>
</template>

<script>
import { differenceInDays } from 'date-fns'

export default {
  name: 'AddedDate',
  props: {
    date: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      default: () => {
        return 7
      },
    },
  },
  computed: {
    addedInDays() {
      const created = this.date * 1000
      const addedSince = differenceInDays(new Date(), new Date(created))
      return addedSince
    },
  },
  methods: {
    shouldDisplayAddedDays() {
      return this.addedInDays <= this.limit
    },
    getAddedInDaysText() {
      let text = 'Added today'
      if (this.addedInDays > 0) {
        text = `Added ${this.addedInDays} days ago`
      }
      return text
    },
  },
}
</script>
<style lang="scss">
.added-date {
  &__wrapper {
    display: flex;
    background: var(--purple-gradient);
    box-shadow: var(--purple-light-box-shadow);
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    padding: 8px 10px;
    height: 30px;
  }
  &__value {
    font-size: rem(12px);
    color: var(--white);
  }
}
</style>
